var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "450" } },
    [
      _c("w-card-title", [_vm._v("Kies een automatisch bericht")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-list",
            { attrs: { loaded: _vm.loaded } },
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "w-list-item",
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return _vm.onClick(item.value)
                    },
                  },
                },
                [_c("w-list-item-text", [_vm._v(_vm._s(item.text))])],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v("Annuleren"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }